import BigNumber from 'BigNumber.js'

export default {
  methods: {
    formatCurrency: function (amount) {
      try {
        return (new BigNumber(amount.toString().split('.')[0])).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } catch (e) {
        return amount
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/util.js